/* Header overlay – comportamentos seguros com seções da Shopify */
(function () {
  function onSection(fn){
    ['shopify:section:load','shopify:section:unload','shopify:section:select','shopify:section:deselect','shopify:block:select','shopify:block:deselect']
      .forEach(e=>document.addEventListener(e,fn));
  }

  function initHeaderOverlay(){
    const isHome = (document.body.getAttribute('data-template') || '').includes('index');
    const headerWrapper = document.querySelector('.header-wrapper');
    if (!headerWrapper) return;

    if (isHome){
      // evita pulo quando o header vira fixed
      const root = document.documentElement;
      const setSpacer = () => {
        const hh = getComputedStyle(root).getPropertyValue('--header-height') || '0px';
        if (document.querySelector('.section-header.scrolled-past-header')){
          document.body.style.paddingTop = hh;
        } else {
          document.body.style.paddingTop = '';
        }
      };
      setSpacer();
      window.addEventListener('scroll', setSpacer, { passive:true });
    } else {
      document.body.style.paddingTop = '';
    }
  }

  document.addEventListener('DOMContentLoaded', initHeaderOverlay);
  onSection(initHeaderOverlay);
})();

/* Optional: sliders desktop – apenas se habilitar “Enable desktop slider” na seção */
(function () {
  function onSection(fn){
    ['shopify:section:load','shopify:section:unload','shopify:section:select','shopify:section:deselect']
      .forEach(e=>document.addEventListener(e,fn));
  }
  function initFeaturedCollection(){
    document.querySelectorAll('.slider--desktop').forEach(slider=>{
      slider.setAttribute('data-show-arrows','true');
    });
  }
  document.addEventListener('DOMContentLoaded', initFeaturedCollection);
  onSection(initFeaturedCollection);
})();

/* === Featured Collection: carrossel JS-only (4 itens desktop / 2 mobile) === */
(function () {
  // Config
  const DESKTOP_BP = 990;     // >= 990px é desktop
  const PER_VIEW_DESKTOP = 4; // 4 por vez
  const PER_VIEW_MOBILE  = 2; // 2 por vez

  const INIT_ATTR = 'data-js-carousel-init';

  function perView() {
    return window.innerWidth >= DESKTOP_BP ? PER_VIEW_DESKTOP : PER_VIEW_MOBILE;
  }

  function initOne(grid) {
    if (!grid || grid.hasAttribute(INIT_ATTR)) return;

    const items = Array.from(grid.querySelectorAll(':scope > li'));
    if (items.length <= perView()) return;

    grid.setAttribute(INIT_ATTR, 'true');

    const inner = document.createElement('div');
    inner.className = 'js-carousel-inner';
    items.forEach(li => inner.appendChild(li));
    grid.appendChild(inner);

    const controls = document.createElement('div');
    controls.className = 'js-carousel-controls';
    controls.innerHTML = `
      <button class="js-prev" aria-label="Anterior" type="button">‹</button>
      <button class="js-next" aria-label="Próximo"  type="button">›</button>
    `;
    grid.parentElement.appendChild(controls);

    let index = 0;
    let pv = perView();
    let slideW = 0;

    function compute() {
      pv = perView();
      const first = inner.children[0];
      if (first) {
        const rect = first.getBoundingClientRect();
        if (inner.children[1]) {
          const r1 = inner.children[1].getBoundingClientRect();
          slideW = r1.left - rect.left;
        } else {
          slideW = rect.width;
        }
      }
      const maxIndex = Math.max(0, Math.ceil(items.length / pv) - 1);
      if (index > maxIndex) index = maxIndex;
      go(index, false);
      updateButtons();
    }

    function maxIndex() {
      return Math.max(0, Math.ceil(items.length / pv) - 1);
    }

    function go(i, animate = true) {
      index = Math.max(0, Math.min(i, maxIndex()));
      inner.style.transition = animate ? 'transform .35s ease' : 'none';
      const offset = index * slideW * pv;
      inner.style.transform = `translateX(${-offset}px)`;
    }

    function updateButtons() {
      controls.querySelector('.js-prev').disabled = index <= 0;
      controls.querySelector('.js-next').disabled = index >= maxIndex();
    }

    controls.querySelector('.js-prev').addEventListener('click', () => { go(index - 1); updateButtons(); });
    controls.querySelector('.js-next').addEventListener('click', () => { go(index + 1); updateButtons(); });

    let startX = 0, dragging = false;
    inner.addEventListener('pointerdown', e => { dragging = true; startX = e.clientX; inner.setPointerCapture(e.pointerId); inner.style.cursor = 'grabbing'; });
    inner.addEventListener('pointerup',   e => { 
      if (!dragging) return; dragging = false; inner.releasePointerCapture(e.pointerId); inner.style.cursor = '';
      const dx = e.clientX - startX;
      if (Math.abs(dx) > 40) {
        if (dx < 0) go(index + 1); else go(index - 1);
        updateButtons();
      } else {
        go(index);
      }
    });
    inner.addEventListener('pointermove', e => {
      if (!dragging) return;
      const dx = e.clientX - startX;
      inner.style.transition = 'none';
      const offset = index * slideW * pv - dx;
      inner.style.transform = `translateX(${-offset}px)`;
    });

    window.addEventListener('resize', compute);
    ['shopify:section:load','shopify:section:select','shopify:section:deselect'].forEach(evt => {
      document.addEventListener(evt, compute);
    });

    compute();
  }

  function initAll() {
    const grids = document.querySelectorAll('slider-component ul.grid.product-grid.contains-card');
    grids.forEach(initOne);
  }

  const css = `
    slider-component ul.grid.product-grid.contains-card {
      position: relative;
      overflow: hidden;
    }
    .js-carousel-inner {
      display: flex;
      gap: var(--js-gap, 32px);
      will-change: transform;
    }
    @media (min-width: 990px) {
      .js-carousel-inner > li { flex: 0 0 calc((100% - (var(--js-gap, 32px) * 3)) / 4); }
    }
    @media (max-width: 989px) {
      .js-carousel-inner > li { flex: 0 0 calc((100% - var(--js-gap, 16px)) / 2); }
      .js-carousel-inner { gap: var(--js-gap, 16px); }
    }
    .js-carousel-controls {
      display: flex; gap: 12px; justify-content: flex-end; align-items: center;
      margin-top: 12px;
    }
    .js-carousel-controls .js-prev,
    .js-carousel-controls .js-next {
      border: 0; padding: 8px 12px; border-radius: 999px;
      background: #111; color: #fff; cursor: pointer;
    }
    .js-carousel-controls .js-prev[disabled],
    .js-carousel-controls .js-next[disabled] {
      opacity: .35; cursor: default;
    }
  `;
  const styleTag = document.createElement('style');
  styleTag.textContent = css;
  document.head.appendChild(styleTag);

  document.addEventListener('DOMContentLoaded', initAll);
})();